import type { Project } from '@/api/client';
import type { FilterRule } from './filterRuleTypes';
import { normalizeMultiPersonRule } from './primitives';

/** Отметки проекта (миграция 179): фильтр — выбор стадий по названию цвета; стадия 0..3 — индекс */
export const FLAG_STAGE_FILTER_LABELS = ['Серый', 'Красный', 'Жёлтый', 'Зелёный'] as const;
export const FLAG_FILTER_COLUMNS = ['project_phonogram', 'project_dp', 'project_pdf', 'project_approved', 'project_done'] as const;
export type FlagFilterColumn = (typeof FLAG_FILTER_COLUMNS)[number];

export function isFlagFilterColumn(columnId: string): columnId is FlagFilterColumn {
  return (FLAG_FILTER_COLUMNS as readonly string[]).includes(columnId);
}

export function flagStageFilterLabel(project: Project, columnId: FlagFilterColumn): string {
  return FLAG_STAGE_FILTER_LABELS[project[columnId] ?? 0] ?? FLAG_STAGE_FILTER_LABELS[0];
}

/** Старые цвета в сохранённых фильтрах — в названия стадий */
const LEGACY_COLOR_LABEL: Record<string, string> = { '': 'Серый', red: 'Красный', orange: 'Жёлтый', blue: 'Зелёный' };

/**
 * Сохранённое правило отметки — в выбор стадий: boolean (Согласовано, Сдан и когда-то ЦП) — зелёный / серый,
 * старые цвета ('red', 'blue', '') — их стадии.
 */
export function migrateFlagFilterRule(rule: FilterRule): FilterRule {
  if (rule.type === 'boolean') {
    if (rule.value === true) return { type: 'select', values: ['Зелёный'] };
    if (rule.value === false) return { type: 'select', values: ['Серый'] };
    return { type: 'select', values: [] };
  }
  if (rule.type === 'select') return { ...rule, values: rule.values.map((v) => LEGACY_COLOR_LABEL[v] ?? v) };
  return rule;
}

/** Нормализация правила при загрузке проектной таблицы из localStorage. */
export function normalizeProjectFilterRuleOnLoad(columnId: string, rule: FilterRule): FilterRule {
  let r = isFlagFilterColumn(columnId) ? migrateFlagFilterRule(rule) : rule;
  r = normalizeMultiPersonRule(r);
  return r;
}
